import Swiper, { Navigation, Thumbs, Scrollbar } from 'swiper';

export default class ProductSliders {
  constructor(mainSliderSelector, thumbsSliderSelector) {
    // templates
    this.templateMain = document.querySelector('template[data-all-media-main]');
    this.templateThumbs = document.querySelector(
      'template[data-all-media-thumbs]'
    );
    // selectors
    this.mainSliderSelector = mainSliderSelector;
    this.thumbsSliderSelector = thumbsSliderSelector;
    // DOM elements
    this.mainSlider = document.querySelector(this.mainSliderSelector);
    this.thumbsSlider = document.querySelector(this.thumbsSliderSelector);
    // Swiper instances
    this.mainSwiperInstance = null;
    this.thumbsSwiperInstance = null;
  }

  createThumbSlider(currentMediaSize = 0) {
    this.thumbsSwiperInstance = new Swiper(this.thumbsSlider, {
      modules: [Navigation, Thumbs],
      spaceBetween: 24,
      slidesPerView: 8,
      threshold: 8,
      direction: 'vertical',
      loop: currentMediaSize >= 8 ? true : false,
    });
  }

  createMainSlider(currentMediaSize = 0) {
    if (!this.thumbsSwiperInstance) return;
    this.mainSwiperInstance = new Swiper(this.mainSlider, {
      modules: [Navigation, Thumbs, Scrollbar],
      initialSlide: 0,
      watchSlidesProgress: true,
      watchOverflow: true,
      loop: true,
      on: {
        init: () => {
          setTimeout(() => {
            document
              .querySelector('.product-skeleton')
              ?.classList.add('hidden');
            document
              .querySelector('.product-page')
              ?.classList.remove('invisible', 'h-0');
          }, 200);
        },
        transitionStart: (swiper) => {
          const videos = swiper.$el[0].querySelectorAll('video');

          Array.prototype.forEach.call(videos, (video) => {
            video.pause();
            video.currentTime = 0;
          });
        },
        transitionEnd: (swiper) => {
          const activeIndex = swiper.activeIndex;
          const activeSlide = swiper.$el[0].getElementsByClassName('swiper-slide')[activeIndex];
          const activeSlideVideo = activeSlide.getElementsByTagName('video')[0];

          if (activeSlideVideo) {
            activeSlideVideo.play();
          }
        }
      },
      allowSlidePrev: true,
      allowSlideNext: true,
      centeredSlides: currentMediaSize === 1,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      scrollbar: {
        el: '[data-product-slider-scroll-bar]',
        draggable: true,
      },
      spaceBetween: 10,
      breakpoints: {
        0: {
          slidesPerView: 1.3,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        648: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
      },
      mousewheel: {
        forceToAxis: true,
      },
      thumbs: {
        swiper: this.thumbsSwiperInstance,
      },
    });
    return;
  }

  getFilteredMedia(slides, currentVariant) {
    const fragment = new DocumentFragment();
    let currentMediaSize = 0;
    slides.forEach((slide) => {
      const media = slide.querySelector('img') || slide.querySelector('video');
      const itemAlt = media.alt;
      const correctImage =
        itemAlt &&
        currentVariant.selectedOptions.every((item) => {
          const trimedValue = item.value.replace(/ /g, '').toLowerCase();
          const altWithoutSpaces = itemAlt
            .replaceAll('/', '')
            .replaceAll(' ', '')
            .toLowerCase();
          return altWithoutSpaces.includes(trimedValue);
        });
      if (correctImage) {
        fragment.appendChild(slide);
        currentMediaSize += 1;
      }
    });

    // if product has only one variant and alt attributes doesnt have correct options
    if (currentMediaSize == 0) {
      slides.forEach(slide => fragment.appendChild(slide))
      currentMediaSize = slides.length;
    }

    return { fragment, currentMediaSize };
  }

  replaceChildren(parent, newElements) {
    const wrapper = parent.querySelector('.swiper-wrapper');
    wrapper.replaceChildren(newElements);
  }

  reinitThumbSlider(currentVariant) {
    const clonedTemplate = new DocumentFragment();
    clonedTemplate.append(this.templateThumbs.content.cloneNode(true));

    const thumbAllSlides = [...clonedTemplate.children];
    const { fragment, currentMediaSize } = this.getFilteredMedia(
      thumbAllSlides,
      currentVariant
    );

    this.replaceChildren(this.thumbsSlider, fragment)
    this.thumbsSwiperInstance?.destroy(true, true);
    this.createThumbSlider(currentMediaSize);
  }

  reinitMainSlider(currentVariant) {
    const clonedTemplate = new DocumentFragment();
    clonedTemplate.append(this.templateMain.content.cloneNode(true));

    const mainAllSlides = [...clonedTemplate.children];
    const { fragment, currentMediaSize } = this.getFilteredMedia(
      mainAllSlides,
      currentVariant
    );
    this.replaceChildren(this.mainSlider, fragment)

    this.mainSwiperInstance?.destroy(true, true);
    this.createMainSlider(currentMediaSize);
  }

  reinit(currentVariant, isBundle = false) {
    if (!currentVariant || isBundle) return;
    this.reinitThumbSlider(currentVariant);
    this.reinitMainSlider(currentVariant);
  }

  init() {
    this.createThumbSlider();
    this.createMainSlider();
  }
}